<template>
  <div class="list_message">
    <div class="top">
      <span v-if="category == 1" class="name">{{record.title}}</span>
      <span v-if="category == 5" class="name">{{record.operatingName}}</span>
      <span v-if="category == 2 || category == 3 || category == 4" class="name">{{record.title}}</span>
      <span class="state draft" v-if="record.statue == 1">草稿</span>
      <span class="state examine" v-if="record.statue == 10">审核中</span>
      <span class="state adopt" v-if="record.statue == 20">审核通过</span>
      <span class="state reject" v-if="record.statue == 30">审核驳回</span>
      <span class="state release" v-if="record.statue == 40">发布</span>
      <span class="state offline" v-if="record.statue == 50">下线</span>

      <span class="state examine" v-if="record.operatingStatus == 0">审核中</span>
      <span class="state adopt" v-if="record.operatingStatus == 1">发布</span>
      <span class="state reject" v-if="record.operatingStatus == 2">审核驳回</span>
      <span class="state offline" v-if="record.operatingStatus == 3">下线</span>
      
    </div>
    <div class="body" v-if="category == 1">
      <p class="content">
        <span class="title">建设地点：</span>
        <span class="obj">{{record.locationName}}</span>
      </p>
      <p class="content">
        <span class="title">项目类别：</span>
        <span class="obj">{{record.projectTypeName}}</span>
      </p>
      <p class="content">
        <span class="title">投资金额：</span>
        <span class="obj">{{record.investmentMoney}}</span>
      </p>
      <p class="content">
        <span class="title">创建时间：</span>
        <span class="obj">{{record.createTime}}</span>
      </p>
    </div>
    <div class="body" v-if="category == 2">
      <p class="content">
        <span class="title">发布地点：</span>
        <span class="obj">{{record.locationName}}</span>
      </p>
      <p class="content">
        <span class="title">创建时间：</span>
        <span class="obj">{{record.createTime}}</span>
      </p>
    </div>
    <div class="body" v-if="category == 3 || category == 4 || category == 5">
      <p class="content">
        <span class="title">创建时间：</span>
        <span class="obj">{{record.createTime}}</span>
      </p>
    </div>
    <div class="foot">
      <div v-if="category == 1">
        <span  @click="setRejectReasonL(record.rejectReason) && $router.push({path: '/investment/inforDetails',query:{id:record.id, category:category, infoId:record.infoId}})">查看详情</span>
        <img  @click="setRejectReasonL(record.rejectReason) && $router.push({path: '/investment/inforDetails',query:{id:record.id, category:category, infoId:record.infoId}})" src="../../../assets/investment/jinru.png" alt="">
      </div>
      <div v-else>
        <span  @click="setRejectReasonL(record.rejectReason) && $router.push({path: '/investment/inforDetails',query:{id:record.id, category:category}})">查看详情</span>
        <img  @click="setRejectReasonL(record.rejectReason) && $router.push({path: '/investment/inforDetails',query:{id:record.id, category:category}})" src="../../../assets/investment/jinru.png" alt="">
      </div>
      <div class="right" v-if="category == 1">招商项目</div>
      <div class="right" v-if="category == 2">营商环境</div>
      <div class="right" v-if="category == 3">联系我们</div>
      <div class="right" v-if="category == 4">合作企业</div>
      <div class="right" v-if="category == 5">运营位</div>
    </div>
  </div>
</template>

<script>
import { mapActions} from 'vuex'

export default {
  name: "listInformation",
  components: {},
  props: {
    record: {
      id: '',
      title: '',
      projectName: '',
      statueName: '',
      statue: '',
      locationName: '',
      projectTypeName: '',
      createTime: '',
      investmentMoney: '',
      rejectReason: ''
    },
    category: Number
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions("investment", [
            "setRejectReasonL"
        ]),
  },
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.list_message {
    background: #FFFFFF;
    padding: 12px 20px;
    border-radius: 3px;
    margin-top: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04);
    .top{
      display: flex;
      justify-content: space-between;
      word-break:break-all;
      .name{
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .state{
        margin-left: 20px;
        white-space: nowrap;
        font-size: 12px;
        line-height: 22px;
      }
      .draft{
        color: #FFD338;
      }
      .examine{
        color: #FF8C19;
      }
      .adopt{
        color: #36B374;
      }
      .reject{
        color: #FF4D4D;
      }
      .release{
        color: #36B374;
      }
      .offline{
        color: #999999;
      }
    }
    .body{
      padding-top: 12px;
      border-bottom: 0.5px solid #EEEEEE;

      .content{
        margin-bottom: 12px;
        line-height: 17px;
        color: #333333;
      }
    }
    .foot{
      padding-top: 12px;
      display: flex;
      justify-content: space-between;
      .right{
        color: #999999;
        line-height: 17px;
      }
      span{
        display: inline-block;
        color: #36B374;
        line-height: 17px;
        font-size: 12px;
      }
      img{
        display: inline-block;
        width: 4px;
        height: 8px;
        margin-left: 5px;
      }
    }
}
</style>